import React from "react";

const EmailIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.6974 15.8335C21.6974 17.8601 20.0488 19.5062 18.0247 19.5062H5.97513C3.95102 19.5062 2.30238 17.8601 2.30238 15.8335V8.16649C2.30238 7.49008 2.48758 6.85479 2.80905 6.30954L8.68849 12.189C9.5681 13.0712 10.746 13.5573 12.0011 13.5573C13.2537 13.5573 14.4316 13.0712 15.3112 12.189L21.1907 6.30954C21.5122 6.85479 21.6973 7.49004 21.6973 8.16649V15.8335H21.6974ZM18.0246 4.49378H5.97513C5.13925 4.49378 4.36764 4.77668 3.75039 5.24735L9.68899 11.1885C10.3037 11.8006 11.1241 12.1401 12.0011 12.1401C12.8756 12.1401 13.6961 11.8006 14.3107 11.1885L20.2493 5.24735C19.6321 4.77668 18.8606 4.49378 18.0246 4.49378ZM18.0246 3.07666H5.97513C3.16914 3.07666 0.885254 5.36055 0.885254 8.16654V15.8335C0.885254 18.6421 3.16914 20.9234 5.97513 20.9234H18.0246C20.8306 20.9234 23.1145 18.6421 23.1145 15.8335V8.16649C23.1145 5.3605 20.8306 3.07666 18.0246 3.07666Z"
          fill="#1F1F1F"
        />
      </svg>
    </>
  );
};

export default EmailIcon;
